import { APP_INITIALIZER, Provider } from '@angular/core';
import { VibeKanbanCompanionService } from '../services/vibe-kanban-companion.service';

/**
 * Provides the CSS selector copy tool for local development.
 * The service is automatically initialized when the app starts,
 * but only if enableWebCompanion is true in the environment config.
 */
export function provideSelectorCopyTool(): Provider {
  return {
    provide: APP_INITIALIZER,
    useFactory:
      (_selectorCopyService: VibeKanbanCompanionService): (() => Promise<void>) =>
      (): Promise<void> =>
        // Service is auto-initialized in constructor based on environment config
        Promise.resolve(),
    deps: [VibeKanbanCompanionService],
    multi: true
  };
}
